<template>
    <el-input placeholder="组件名称"
        size="small"
        clearable
        v-model="model">
        <i slot="suffix"
            class="el-input__icon el-icon-search"></i>
    </el-input>
</template>

<script>
export default {
    name: 'componentNameInput',
    props: {
        value: String,
        update: Function
    },
    data() {
        return {
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.update(val)
            }
        }
    }
}
</script>
